/** @file anchorPx: an entry's anchor (pivot) pixel from its fraction, and a typed pixel back to a valid one. */
import { movePivot } from '../viewport/movePivot';

/**
 * `pivotFrac x size` per axis (image px from the tile's top-left); with `typed` (one axis set to a typed pixel), that
 * pixel snapped to the half pixel and clamped to `[0, size]` (the pivot diamond's rule, `movePivot`) instead.
 */
export function anchorPx(
  size: readonly [number, number], pivotFrac: readonly [number, number], typed?: { axis: 0 | 1; px: number },
): [number, number] {
  const px: [number, number] = [pivotFrac[0] * size[0], pivotFrac[1] * size[1]];
  if (typed === undefined) return px;
  const delta: [number, number] = typed.axis === 0 ? [typed.px - px[0], 0] : [0, typed.px - px[1]];
  return movePivot(size, px, delta);
}
